module.exports = __webpack_public_path__ + "static/img/team-bg-blue.22b7108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-bg-blue.png
// module id = 2PMg
// module chunks = 0